import { isLocalNetworkHostname } from 'shared/utils/is-local-network-hostname'
import { resolveHostnameParts } from 'shared/utils/resolve-hostname-parts'
import { defaultBrandSettings } from '../constants/brand-settings'
import { BrandSettingsInterface } from '../types/brand-settings'
import { getGlobalBrand } from './global-brand'

const getFallbackBrand = (): BrandSettingsInterface => {
  const envHostname = process.env.NEXT_PUBLIC_SIO_HOSTNAME

  if (envHostname) {
    return {
      ...defaultBrandSettings,
      dashboardHostname: envHostname,
    }
  }

  return defaultBrandSettings
}

const getBrand = (brand?: BrandSettingsInterface | null) =>
  brand ?? getGlobalBrand() ?? getFallbackBrand()

export const getDashboardHostname = (brand?: BrandSettingsInterface | null) =>
  getBrand(brand).dashboardHostname || defaultBrandSettings.dashboardHostname

export const getDashboardBaseUrl = (brand?: BrandSettingsInterface | null) => {
  const { hostname, protocol } = resolveHostnameParts(getDashboardHostname(brand))

  if (!hostname) {
    return ''
  }

  const normalizedHostname = hostname.replace(/\/+$/, '')
  const fallbackProtocol = protocol
    ? protocol
    : isLocalNetworkHostname(normalizedHostname)
      ? 'http'
      : 'https'

  return `${fallbackProtocol}://${normalizedHostname}`
}

export const buildDashboardUrl = (path: string, brand?: BrandSettingsInterface | null) => {
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : ''
  const baseUrl = getDashboardBaseUrl(brand)

  if (!baseUrl) {
    return normalizedPath || '/'
  }

  return `${baseUrl}${normalizedPath}`
}
